<template>
  <OArticleCard v-bind="$attrs" class="mb-4 sm:mb-8">
    <OArticleCover class="rounded-none sm:rounded-md" :width="240" />
    <OArticleTitle :level="4" class="hover:text-link-primary mt-2 text-base line-clamp-4 mb-3" />
  </OArticleCard>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
  },
  inheritAttrs: false,
});
</script>
